import { SVGLogos, WEBPLogos } from 'common/www/assets/CompanyLogos';
import Headshots from 'common/www/assets/Headshots';

export const OrcaScan = (
  body = "Canny's Autopilot ensures feature requests never fall through the cracks. We've seen an 80% increase in requests logged since introducing Autopilot.",
) => ({
  linkUrl: '/case-studies/',
  logo: {
    alt: 'Orca Scan',
    src: WEBPLogos.OrcaScan,
    height: 32,
    width: 146,
  },
  body,
  person: {
    imageUrl: Headshots.OwenDoherty,
    name: 'Owen Doherty',
    title: 'COO',
  },
});

const Pallyy = (
  body = 'The feedback started coming in on auto-pilot. It was just a stream of incoming tickets. This helped guide Pallyy in the early days.',
) => ({
  linkUrl: '/case-studies/pallyy',
  logo: {
    alt: 'Pallyy',
    src: WEBPLogos.Pallyy,
    height: 32,
    width: 98,
  },
  body,
  person: {
    imageUrl: Headshots.TimBennetto,
    name: 'Tim Bennetto',
    title: 'Founder',
  },
});

export const CreditRepairCloud = (
  body = "I LOVE how it auto-scans our support tickets and magically finds feedback. We've been able to 10x our feedback & remove many duplicate posts.",
) => ({
  linkUrl: '/case-studies/',
  logo: {
    alt: 'Credit Repair Cloud',
    src: WEBPLogos.CreditRepairCloud,
    height: 32,
    width: 150,
  },
  body,
  person: {
    imageUrl: Headshots.KeenanJones,
    name: 'Keenan Jones',
    title: 'VP Product',
  },
});

export const StellarWP = (
  body = "We're seeing hundreds of support tickets turned into actionable insights both unique and as votes on existing posts with very high accuracy.",
) => ({
  linkUrl: '/case-studies/',
  logo: {
    alt: 'Stellar WP',
    src: WEBPLogos.StellarWP,
    height: 32,
    width: 157,
  },
  body,
  person: {
    imageUrl: Headshots.MattCromwell,
    name: 'Matt Cromwell',
    title: 'Senior Director, CX',
  },
});

export const CircleCI = (
  body = 'It just makes our lives easier from the product perspective, to be able to go to this one tool and see everything.',
) => ({
  linkUrl: '/case-studies/circleci',
  logo: {
    alt: 'Circle CI',
    src: SVGLogos.CircleCI,
    height: 32,
    width: 153,
  },
  body,
  person: {
    imageUrl: Headshots.LiyaAi,
    name: 'Liya Ai',
    title: 'Product Operations Manager',
  },
});

export const AgencyAnalytics = (
  body = 'Thanks to Canny, we find the issues that are most requested, avoid churn, and generate more revenue.',
) => ({
  linkUrl: '/case-studies/agencyanalytics',
  logo: {
    alt: 'Agency Analytics',
    src: SVGLogos.AgencyAnalytics,
    height: 32,
    width: 218,
  },
  body,
  person: {
    imageUrl: Headshots.JayPatel,
    name: 'Jay Patel',
    title: 'Product Manager',
  },
});

export const Mercury = (
  body = "We use Canny as a way to distribute product thinking across the team. Now that everything is in one place, it's so much easier and more efficient.",
) => ({
  linkUrl: '/case-studies/mercury',
  logo: {
    alt: 'Mercury',
    src: SVGLogos.Mercury,
    height: 32,
    width: 173,
  },
  body,
  person: {
    imageUrl: Headshots.IdaStrom,
    name: 'Ida Ström',
    title: 'Senior Product Designer',
  },
});

export const Aryeo = (
  body = 'Canny has reduced the number of inbounds in our support inbox by 20%, which is a big deal.',
) => ({
  linkUrl: '/case-studies/aryeo',
  logo: {
    alt: 'Aryeo',
    src: SVGLogos.Aryeo,
    height: 32,
    width: 117,
  },
  body,
  person: {
    imageUrl: Headshots.ChelseaDarby,
    name: 'Chelsea Darby',
    title: 'Customer Success',
  },
});

export const Figured = (
  body = 'Suddenly, everything from Canny to Intercom to Slack was linked. We were actually able to record what people wanted in one place, with basically no effort.',
) => ({
  linkUrl: '/case-studies/figured',
  logo: {
    alt: 'Figured',
    src: SVGLogos.Figured,
    height: 32,
    width: 92,
  },
  body,
  person: {
    imageUrl: Headshots.NickBarraclough,
    name: 'Nick Barraclough',
    title: 'Partner Success Manager',
  },
});

export const Knak = (
  body = "Gathering and analyzing feedback is so much more quick and efficient now, and it's saving us a lot of time.",
) => ({
  linkUrl: '/case-studies/knak',
  logo: {
    alt: 'Knak',
    src: SVGLogos.Knak,
    height: 32,
    width: 104,
  },
  body,
  person: {
    imageUrl: Headshots.FelixHiggs,
    name: 'Felix Higgs',
    title: 'Senior CSM',
  },
});

export const Strapi = (
  body = "Canny even helps us win deals. When a prospect requests a feature, it's easy for the sales team to log it in and follow up once it's shipped.",
) => ({
  linkUrl: '/case-studies/strapi',
  logo: {
    alt: 'Strapi',
    src: SVGLogos.Strapi,
    height: 32,
    width: 134,
  },
  body,
  person: {
    imageUrl: Headshots.AurelienGeorget,
    name: 'Aurélien Georget',
    title: 'Chief Product Officer',
  },
});

export const Jane = (
  body = 'When our sales reps are talking to a prospect, they often hear a request for a very specific feature. Now, they can quickly log that in Canny and mention how important it is.',
) => ({
  linkUrl: '/case-studies/janetechnologies',
  logo: {
    alt: 'Jane',
    src: SVGLogos.Jane,
    height: 32,
    width: 121,
  },
  body,
  person: {
    imageUrl: Headshots.RachelSchaaf,
    name: 'Rachel Schaaf',
    title: 'Senior Director',
  },
});

export const GiveButter = (
  body = 'As the sales team is working with the prospect, they use Canny to add new requests and upvote existing ones on behalf of those prospects. That really signals to us that we should prioritize certain features.',
) => ({
  linkUrl: '/case-studies/givebutter',
  logo: {
    alt: 'GiveButter',
    src: SVGLogos.GiveButter,
    height: 32,
    width: 208,
  },
  body,
  person: {
    imageUrl: Headshots.JesseSandala,
    name: 'Jesse Sandala',
    title: 'Director of Product',
  },
});

export const Hive = (
  body = "Canny is saving us about 2-3 hours per week on product marketing. Instead of going back and forth between various tools, everything lives in Canny now. It's our one source of truth.",
) => ({
  linkUrl: '/case-studies/hive',
  logo: {
    alt: 'Hive',
    src: SVGLogos.Hive,
    height: 32,
    width: 136,
  },
  body,
  person: {
    imageUrl: Headshots.MichaelaRollings,
    name: 'Michaela Rollings',
    title: 'Head of Brand & Content',
  },
});

export const Axios = (
  body = 'Canny really helped us to achieve product-market fit for the app during the beta period.',
) => ({
  linkUrl: '/case-studies/axios',
  logo: {
    alt: 'Axios',
    src: SVGLogos.Axios,
    height: 32,
    width: 126,
  },
  body,
  person: {
    imageUrl: Headshots.MarcusMoretti,
    name: 'Marcus Moretti',
    title: 'Senior Product Director',
  },
});

export const ClickUp = (
  body = "Canny removes our need for user testing entirely, which is something I didn't really anticipate.",
) => ({
  linkUrl: '/case-studies/clickup',
  logo: {
    alt: 'Click Up',
    src: SVGLogos.ClickUp,
    height: 32,
    width: 131,
  },
  body,
  person: {
    imageUrl: Headshots.ZebEvans,
    name: 'Zeb Evans',
    title: 'CEO',
  },
});

export const Missive = (
  body = "Canny really helps us not just with feedback management, but also with decision-making. It pushes us to be more creative with what we're building next. Because, Canny helps us balance user ideas with our own input.",
) => ({
  linkUrl: '/case-studies/missive',
  logo: {
    alt: 'Missive',
    src: SVGLogos.Missive,
    height: 32,
    width: 182,
  },
  body,
  person: {
    imageUrl: Headshots.PhilippeLehoux,
    name: 'Philippe Lehoux',
    title: 'CEO',
  },
});

export const Document360 = (
  body = "Canny came out on top for two reasons: it's very simple to use, and our users love it.",
) => ({
  linkUrl: '/case-studies/document360',
  logo: {
    alt: 'Document360',
    src: SVGLogos.Document360,
    height: 32,
    width: 242,
  },
  body,
  person: {
    imageUrl: Headshots.SaravanaKumar,
    name: 'Saravana Kumar',
    title: 'Founder',
  },
});

export default {
  Document360,
  Missive,
  ClickUp,
  GiveButter,
  Jane,
  CircleCI,
  Hive,
  Strapi,
  Axios,
  Pallyy,
  Knak,
  Figured,
  Aryeo,
  Mercury,
  AgencyAnalytics,
  OrcaScan,
  CreditRepairCloud,
  StellarWP,
};
